// extracted by css-extract-rspack-plugin
export default {"list":"list-wpafoB","item":"item-yOXnvm"};